import { render, staticRenderFns } from "./display_options.vue?vue&type=template&id=15bceb25&lang=pug&"
import script from "./display_options.vue?vue&type=script&lang=coffee&"
export * from "./display_options.vue?vue&type=script&lang=coffee&"
import style0 from "./display_options.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./display_options.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports